/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Preview_Label_ButtonInputs */



/**
* | output |
* | --- |
* | "Preview recording" |
*
* @param {Audio_Recorder_Preview_Label_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_preview_label_button = /** @type {((inputs?: Audio_Recorder_Preview_Label_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Preview_Label_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prévisualiser l'enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschauaufnahme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima della registrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр записи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de la grabación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览录制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビュー録画")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग का पूर्वावलोकन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização da gravação")
	return /** @type {LocalizedString} */ ("Preview recording")
});